import React, { Component } from "react"
import { inject, observer } from "mobx-react"
import styled from "styled-components"

import constants from "~/style/constants"
import FormError from "~/components/Form/ErrorText"
import withTranslations from "~/components/_hocs/withTranslations"

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const Input = styled.input`
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-appearance: none;
  text-align: left;
  background: white;
  box-shadow: ${(props) =>
    props.$compact
      ? "0 2px 8px rgba(35, 41, 48, 0.06)"
      : "0px 8px 15px 0px rgba(35, 41, 48, 0.15)"};
  outline: none;
  height: ${(props) => (props.$compact ? "48px" : "70px")};
  width: 100%;
  max-width: ${(props) => (props.$compact ? "100%" : "364px")};
  padding-left: 20px;
  font-family: ${(props) => props.theme.fonts.avenirNextRegular};
  font-size: 1rem;
  caret-color: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.text.input};
  &::placeholder {
    color: ${(props) => props.theme.colors.text.inputPlaceholder};
  }
  border: 1px solid
    ${(props) =>
      props.error ? props.theme.colors.error : constants.colors.ui.borderGray};
  border-radius: ${(props) => (props.$compact ? "10px" : "4px")};

  @media (max-width: 768px) {
    height: ${(props) => (props.$compact ? "48px" : "56px")};
    font-size: 0.9rem;
    max-width: 100%;
    padding-left: 16px;
  }

  @media (max-width: 480px) {
    height: ${(props) => (props.$compact ? "44px" : "48px")};
    font-size: 0.85rem;
  }
`

@inject((all) => ({
  validateDisplayMessage: all.store.trafficLookup.validateDisplayMessage,
  changeZipCode: all.store.trafficLookup.changeZipCode,
  zipCode: all.store.trafficLookup.zipCode,
}))
@observer
class ZipCodeInput extends Component {
  handleZipCodeChange = (event) => {
    const { value } = event.target
    this.props.changeZipCode(value)
  }

  render() {
    const zipCodeErrorHandler = this.props.validateDisplayMessage("zipCode")
    return (
      <Wrap>
        <Input
          $compact={this.props.compact}
          placeholder={this.props.translate("placeholder")}
          onChange={this.handleZipCodeChange}
          value={this.props.zipCode}
          error={zipCodeErrorHandler}
          type="text"
        />
        <FormError error={zipCodeErrorHandler} />
      </Wrap>
    )
  }
}

export default withTranslations(ZipCodeInput, "form.traffic.zipCodeDOB")
